import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import { formatStudentSex } from "utils/studentSexI18n";

/**
 * Action buttons column (Edit / Assign / Delete)
 */
function ActionButtons({ row, onEdit, onDelete, t }) {
  const user = row.original;
  return (
    <>
      <MDButton
        variant="text"
        color="info"
        onClick={() => onEdit(user)}
        title={t ? t("students.table.actions.edit", "Edit") : "Edit"}
      >
        <Icon>edit</Icon>
      </MDButton>
    </>
  );
}

ActionButtons.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

ActionButtons.defaultProps = {
  t: null,
};

/**
 * Exported table builder with language support
 */
export default function UsersDataTable({ users, onEdit, onDelete, onAssign, t }) {
  return {
    columns: [
      {
        Header: t ? t("students.table.columns.actions", "Actions") : "Actions",
        accessor: "actions",
        Cell: (props) => <ActionButtons {...props} onEdit={onEdit} t={t} />,
      },
      {
        Header: t ? t("students.table.columns.name", "Name") : "Name",
        accessor: "name",
      },
      {
        Header: t ? t("students.table.columns.sex", "Sex") : "Sex",
        accessor: "sex",
        Cell: ({ row }) => formatStudentSex(row.original.sex ?? row.original.gender, t),
      },
      {
        Header: t ? t("students.table.columns.age", "Age") : "Age",
        accessor: "age",
      },
      {
        Header: t ? t("students.table.columns.studentAppId", "Student App ID") : "Student App ID",
        accessor: "app_student_id",
      },
      {
        Header: t ? t("students.table.columns.programName", "Program Name") : "Program Name",
        accessor: "program_name",
      },
    ],
    rows: (users || []).map((user) => ({
      ...user,
      actions: "", // placeholder; actual buttons are rendered by the Cell
    })),
  };
}

UsersDataTable.propTypes = {
  users: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

UsersDataTable.defaultProps = {
  t: null,
};
